export default "__VITE_ASSET__C7mY5yj7__"